/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {usePostRequest} from "../../../../../api/helper";
import ADAS_PROGRAMS_CONSTANTS from "../../../AdasPrograms/constants";
import * as React from "react";
import {useEffect, useMemo} from "react";
import {toast} from "react-hot-toast";
import BoxWithCenteredContent from "../../../../components/Containers/BoxWithCenteredContent";
import Loader from "../../../../components/Loader/Loader";
import {FormControl, InputLabel, ListItemText} from "@mui/material";
import ArgosSelect from "../../../../components/Form/Select/ArgosSelect";
import ArgosMenuItem from "../../../../components/Form/Select/ArgosMenuItem";


const SELECT_BOX_WIDTH = 400

const SelectAdasProgram = (props: any) => {
  const {onChange} = props

  const packagesDataFetchHandle = usePostRequest(ADAS_PROGRAMS_CONSTANTS.itemDetails.coverageRequirements.fetchAdasPrograms)
  const [isLoadingAdasProgramsData, setIsLoadingAdasProgramsData] = React.useState(false)
  const [adasProgramsData, setAdasProgramsData] = React.useState<any>(null)
  const [adasProgramsToModelYears, setAdasProgramsToModelYears] = React.useState<any>(null)

  const [selectedAdasProgramName, setSelectedAdasProgramName] = React.useState<string>("")
  const [selectedModelYear, setSelectedModelYear] = React.useState<string>("")

  const adasProgramId: string | null = useMemo(() => {
    if (!adasProgramsData || !selectedAdasProgramName || !selectedModelYear) return null
    let adasProgramItemData: any = {}
    adasProgramsData.forEach((element: any) => {
      if (element?.data?.programName === selectedAdasProgramName && element?.data?.modelYear === selectedModelYear) {
        adasProgramItemData = element
        return true
      }
    })
    return adasProgramItemData.adasProgramId
  }, [adasProgramsData, selectedAdasProgramName, selectedModelYear])

  useEffect(() => {
    onChange({selectedAdasProgramName, selectedModelYear, adasProgramId})
  }, [selectedAdasProgramName, selectedModelYear, adasProgramId]);

  const fetchPackageData = () => {
    setIsLoadingAdasProgramsData(true)
    packagesDataFetchHandle().then((data) => {
      const _adasProgramsToModelYears: any = {}
      data.forEach((element: any) => {
        const elementData = element?.data
        const programName = elementData?.programName
        const modelYear = elementData?.modelYear
        if (programName in _adasProgramsToModelYears) {
          _adasProgramsToModelYears[programName].push(modelYear)
        } else {
          _adasProgramsToModelYears[programName] = [modelYear]
        }
      })
      setAdasProgramsData(data)
      setAdasProgramsToModelYears(_adasProgramsToModelYears)
      setIsLoadingAdasProgramsData(false)
    }).catch((e) => {
      console.error(e)
      toast.error("Failed to fetch Adas Programs data")
      setIsLoadingAdasProgramsData(false)
    })
  }

  useEffect(() => {
    fetchPackageData()
  }, [])

  return (
    <BoxWithCenteredContent vertical
                            style={{height: '100%', display: 'flex', flexFlow: 'column nowrap', padding: 10}}>
      {isLoadingAdasProgramsData && <span>Loading ADAS programs</span>} <Loader isLoading={isLoadingAdasProgramsData} wrapperStyle={{height: 'auto'}}/>
      <FormControl sx={{width: SELECT_BOX_WIDTH}}>
        <InputLabel id="category-select-label">
          Adas Program
        </InputLabel>
        <ArgosSelect
          labelId="category-select-label"
          id="category-select"
          value={selectedAdasProgramName}
          label="Adas Program"
          onChange={(e: any) => setSelectedAdasProgramName(e.target.value)}
          variant="standard"
        >
          {adasProgramsToModelYears && Object.keys(adasProgramsToModelYears).map((option: string) => (
            <ArgosMenuItem key={option} value={option}>
              <ListItemText
                primary={option}
              />
            </ArgosMenuItem>
          ))}
        </ArgosSelect>
      </FormControl>

      <FormControl sx={{width: SELECT_BOX_WIDTH}}>
        <InputLabel id="property-select-label">
          Model Year
        </InputLabel>
        <ArgosSelect
          labelId="property-select-label"
          id="property-select"
          value={selectedModelYear}
          label="Model Year"
          onChange={(e: any) => setSelectedModelYear(e.target.value)}
          variant="standard"
        >
          {adasProgramsToModelYears && adasProgramsToModelYears[selectedAdasProgramName]?.map((option: string) => (
            <ArgosMenuItem key={option} value={option}>
              <ListItemText primary={option}/>
            </ArgosMenuItem>
          ))}
        </ArgosSelect>
      </FormControl>
    </BoxWithCenteredContent>
  )
}

export default SelectAdasProgram